import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getQueue, flush } from "../lib/offlineQueue";
import { CloudOff, CloudUpload, CloudCheck } from "lucide-react";

export default function SyncIndicator() {
  const [count, setCount] = useState(getQueue().length);
  const [syncing, setSyncing] = useState(false);

  const doFlush = async () => {
    if (!getQueue().length || !navigator.onLine) return;
    setSyncing(true);
    const { synced, rejected } = await flush();
    setSyncing(false);
    setCount(getQueue().length);
    if (synced) toast.success(`${synced} offline ${synced === 1 ? "entry" : "entries"} synced`);
    if (rejected) toast.error(`${rejected} queued ${rejected === 1 ? "entry was" : "entries were"} rejected by the server`);
  };

  useEffect(() => {
    const update = () => setCount(getQueue().length);
    window.addEventListener("offline-queue-change", update);
    window.addEventListener("online", doFlush);
    const t = setInterval(doFlush, 30000);
    doFlush();
    return () => {
      window.removeEventListener("offline-queue-change", update);
      window.removeEventListener("online", doFlush);
      clearInterval(t);
    };
  }, []);

  if (count === 0 && !syncing) {
    return (
      <span data-testid="sync-indicator-synced" title="All entries synced" className="flex items-center gap-1 text-[10px] font-semibold text-emerald-400">
        <CloudCheck size={15} /> Synced
      </span>
    );
  }
  return (
    <button data-testid="sync-indicator-pending" onClick={doFlush} title="Tap to retry sync"
      className="flex items-center gap-1.5 rounded-full bg-amber-400/20 px-2.5 py-1 text-[10px] font-bold text-amber-300">
      {syncing ? <CloudUpload size={15} className="animate-pulse" /> : <CloudOff size={15} />}
      {syncing ? "Syncing…" : `${count} pending`}
    </button>
  );
}
